import {
  Base,
  Component,
  InjectReactive,
  Mixins
} from '@/vue-property-decorator'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'
import { _RectangleStarBase as RectangleStarBase } from './cssVar/rectangleStarBase'
import { _TriangleHeartDefault as TriangleHeartDefault } from './cssVar/rectangleStarDefault'
import { _TriangleHeartSmall as TriangleHeartSmall } from './cssVar/rectangleStarSmall'
import { createSvgSprite } from '@/utils/business-utils/assets'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export { RectangleStarBase, TriangleHeartDefault, TriangleHeartSmall }
export type RectangleStarCssVarManager = GetCssVarManager<RectangleStarBase>
/** 长方型的背景,加一个星型的字体图标 */
@Component<RectangleStar>({
  name: 'RectangleStar'
})
export default class RectangleStar extends Mixins<
  Base,
  BaseCssVarInject<RectangleStarBase>
>(Base, BaseCssVarInject) {
  public static getTriangleHeartDefault = () => new TriangleHeartDefault()
  public static getTriangleHeartSmall = () => new TriangleHeartSmall()
  @InjectReactive()
  private isFavorited!: boolean
  render() {
    return (
      <div
        class={{
          [style['rectangle-star']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType),
          [style['is-favorited']]: this.isFavorited
        }}
      >
        <icon-sprite sprite={createSvgSprite('icon_dt_sc2')} />
      </div>
    )
  }
}
